import { render, staticRenderFns } from "./shipment-rules-modal.vue?vue&type=template&id=272bf05a&scoped=true&"
import script from "./shipment-rules-modal.ts?vue&type=script&lang=ts&"
export * from "./shipment-rules-modal.ts?vue&type=script&lang=ts&"
import style0 from "./shipment-rules-modal.scss?vue&type=style&index=0&id=272bf05a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bf05a",
  null
  
)

export default component.exports